<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
        <v-flex xs12>
            <v-toolbar
                color="#eee"
                class="elevation-0 secondary--text"
            >
            <v-toolbar-title>
                APETRUS ANÚNCIOS
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom v-if="step === 1">
                <v-btn
                    icon
                    color='info'
                    slot="activator"
                    @click="step++;$refs.form.reset()"
                >
                    <v-icon>add</v-icon>
                </v-btn>
                <span>Adicionar novo Anúncio</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>
        <v-flex xs12>
          <v-card :color="step === 1 ? 'transparent' : ''" elevation="0">
            <v-card-text>
                <v-stepper
                    v-model="step"
                    class="pa-0 ma-0"
                    style="box-shadow: none;"
                >
                    <v-stepper-items>
                        <v-stepper-content step="1" style="background-color: #EEEEEE;">
                          <v-layout
                            v-if="anuncios && anuncios.length > 0"
                            align-start
                            justify-start
                            row
                            wrap
                            fill-height
                            class="mb-4"
                            style="min-height: 18em;"
                          >
                            <v-flex xs12 sm6 md4 lg3 xl2 v-for="(anuncio, index) in anuncios" :key="index" class="mb-3">
                              <card-anuncio
                                :anuncio="anuncio"
                                @success="showSuccess"
                                @error="showError"
                                @carregar="pegarAnuncios"
                                @visualizarAnuncio="visualizarAnuncio"
                                @editar="editarAnuncio"
                              />
                            </v-flex>
                          </v-layout>
                          <v-card v-else>
                            <v-card-text class="text-xs-center">
                              <h1>AINDA NÃO HÁ ANÚNCIOS CADASTRADOS</h1>
                            </v-card-text>
                          </v-card>
                          <div class="text-xs-center pt-2" v-if="anuncios && anuncios.length > 0 && pages > 1">
                            <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
                          </div>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <h2 class="text-xs-center mb-4">CADASTRAR NOVO ANÚNCIO</h2>
                            <v-form lazy-validation v-model="valid" ref="form" style="width: 100%;">
                              <v-layout wrap justify-space-between class="ma-4">
                                <v-flex xs12 sm12 md8>
                                  <v-text-field
                                    label="Título"
                                    required
                                    v-model="formulario.titulo"
                                    counter="50"
                                    maxlength="50"
                                    outline
                                    :rules="[
                                      v => !!v || 'Campo obrigatório'
                                    ]"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md3>
                                  <v-menu
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    lazy
                                    max-width="290px"
                                    min-width="290px"
                                    :close-on-content-click="false"
                                    v-model="menuDataInicial"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="formulario.data_inicio"
                                        outline
                                        v-on="on"
                                        label="Data inicial"
                                        required
                                        :rules="[
                                              v => !!v || 'O campo é obrigatório'
                                            ]"
                                        readonly
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="date_inicio"
                                      no-title
                                      locale="pt-br"
                                      :allowed-dates="(date) => {
                                        return Date.parse(date) >= today
                                      }"
                                    >
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        flat
                                        color="green darken-1"
                                        class="caption font-weight-medium"
                                        @click="menuDataInicial = false"
                                      >FECHAR</v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs12 sm12 md8>
                                  <v-textarea
                                    label="Descrição"
                                    v-model="formulario.descricao"
                                    counter="200"
                                    maxlength="200"
                                    outline
                                  ></v-textarea>
                                </v-flex>
                                <v-flex xs12 sm12 md3 class="mb-4">
                                  <v-menu
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    lazy
                                    max-width="290px"
                                    min-width="290px"
                                    :close-on-content-click="false"
                                    v-model="menuDataFinal"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-slide-x-transition>
                                        <v-text-field
                                          v-model="formulario.data_fim"
                                          outline
                                          hide-details
                                          v-on="on"
                                          class="pt-2"
                                          readonly
                                          label="Data de Expiração"
                                        ></v-text-field>
                                      </v-slide-x-transition>
                                    </template>
                                    <v-date-picker
                                      v-model="date_fim"
                                      no-title
                                      locale="pt-br"
                                      :allowed-dates="(date) => {
                                        const dataTeste = date_inicio ? Date.parse(date_inicio) : today
                                        return Date.parse(date) >= dataTeste
                                      }"
                                    >
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        flat
                                        color="green darken-1"
                                        class="caption font-weight-medium"
                                        @click="menuDataFinal = false"
                                      >FECHAR</v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs12 sm12 md8>
                                  <v-text-field
                                    label="Link de redirecionamento"
                                    required
                                    outline
                                    counter="200"
                                    maxlength="200"
                                    v-model="formulario.link_redirecionamento"
                                    :rules="[
                                      v => !!v || 'Campo obrigatório'
                                    ]"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md3>
                                  <v-select
                                    label="Link de redirecionamento"
                                    required
                                    outline
                                    :items="destinos_link_redirecionamento"
                                    v-model="formulario.destino_link_redirecionamento"
                                    :rules="[
                                      v => !!v || 'Campo obrigatório'
                                    ]"
                                  />
                                </v-flex>
                                <v-flex xs12 sm12 md3>
                                  <v-switch
                                    v-model="limite_de_visualizacoes"
                                    label="Tem limite de visualização"
                                    color="primary"
                                  ></v-switch>
                                  <v-slide-x-transition>
                                    <div v-if="limite_de_visualizacoes">
                                      <v-text-field
                                        label="Número de visualizações"
                                        required
                                        outline
                                        v-model="formulario.visualizacoes_por_usuario"
                                        type="number"
                                        :rules="[
                                          v => !!v || 'Campo obrigatório'
                                        ]"
                                      ></v-text-field>
                                      <h5>Total de vezes que o usuário visualizará o anúncio</h5>
                                    </div>
                                  </v-slide-x-transition>
                                </v-flex>
                                <v-flex xs12 sm12 md3>
                                  <v-switch
                                    v-model="tem_restricao_cidade"
                                    label="Tem restrição a uma cidade?"
                                    color="primary"
                                  ></v-switch>
                                  <v-slide-x-transition>
                                    <div v-if="tem_restricao_cidade">
                                      <v-text-field
                                        label="Nome da cidade que o anùncio está restrito"
                                        required
                                        outline
                                        v-model="formulario.limitar_a_cidade"
                                        :rules="[
                                          v => !!v || 'Campo obrigatório'
                                        ]"
                                      ></v-text-field>
                                      <h5>Ativando essa função o anúncio aparecerá apenas para usúarios que residem na cidade informada</h5>
                                    </div>
                                  </v-slide-x-transition>
                                </v-flex>
                                <v-flex xs12 sm12 md3>
                                  <v-switch
                                    v-model="tem_restricao_estado"
                                    label="Tem restrição a um estado?"
                                    color="primary"
                                  ></v-switch>
                                  <v-slide-x-transition>
                                    <div v-if="tem_restricao_estado">
                                      <v-select
                                        label="Estado que o anùncio está restrito"
                                        required
                                        outline
                                        v-model="formulario.limitar_a_estado"
                                        :items="estados"
                                        :rules="[
                                          v => !!v || 'Campo obrigatório'
                                        ]"
                                      ></v-select>
                                      <h5>Ativando essa função o anúncio aparecerá apenas para usúarios que residem no estado informado</h5>
                                    </div>
                                  </v-slide-x-transition>
                                </v-flex>
                              </v-layout>
                            </v-form>
                        </v-stepper-content>
                        <v-stepper-content step="3" style="height: 100%;">
                          <v-toolbar color="transparent" elevation="0">
                            <v-spacer></v-spacer>
                            <v-toolbar-title>
                              <h2 class="text-xs-center mb-4">INSIRA A IMAGEM DO ANÚNCIO</h2>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                              <v-btn
                                color="info"
                                slot="activator"
                                @click="imagens.push(undefined)"
                                icon
                              >
                                <v-icon>add</v-icon>
                              </v-btn>
                              <h4 class="info--text">Adicionar Novo Anúncios</h4>
                            </v-tooltip>
                          </v-toolbar>
                          <input
                              type="file"
                              style="display:none"
                              accept="image/*"
                              ref="imagemInput"
                              @input="carregarImagem"
                          />
                          <v-flex xs12 v-show="cropping">
                            <vue-croppie
                              ref="croppie"
                              :enableExif="true"
                              :enforceBoundary="true"
                              :enableResize="false"
                              :enableOrientation="false"
                              :mouseWheelZoom="true"
                              :showZoomer="false"
                              :boundary="{ width: 700, height: 500 }"
                              :viewport="{ width: 600, height: 450}"
                            ></vue-croppie>
                            <v-btn
                              text
                              @click="recortarImagem()"
                              block
                              class="mt-3"
                            >
                              Recortar imagem
                              </v-btn>
                          </v-flex>
                          <v-stepper
                            v-model="step_image"
                            style="box-shadow: none;"
                            v-if="!cropping"
                          >
                            <v-stepper-items style="box-shadow: none;">
                              <v-stepper-content
                                v-for="(item, index) in imagens"
                                :key="index"
                                :step="Number(index) + 1"
                                class="ma-0 pa-0"
                                style="box-shadow: none;"
                              >
                                <v-layout
                                  justify-center
                                  column
                                  style="justify-content: center; align-items: center;"
                                >
                                  <img
                                    v-if="item"
                                    :src="item"
                                    @click="removerImagem(item, index)"
                                    class="ml-3 mr-3 mt-2"
                                    width="600"
                                    slot="activator"
                                  />
                                  <v-progress-circular
                                    v-else-if="loading && !item"
                                    indeterminate
                                    :size="50"
                                    color="info"
                                  ></v-progress-circular>
                                  <v-tooltip
                                    bottom
                                    v-else-if="!cropping"
                                  >
                                    <template  v-slot:activator="{ on }">
                                      <v-card
                                        hover
                                        class="ml-3 mr-3 mt-2 mb-2"
                                        width="600"
                                        v-on="on"
                                        @click="$refs.imagemInput.click(), indexSelecionado = index"
                                        :loading="loading"
                                      >
                                        <v-layout justify-center column>
                                          <v-icon size="15em">image</v-icon>
                                        </v-layout>
                                      </v-card>
                                    </template>
                                    <h4>Clique para inserir uma imagem</h4>
                                  </v-tooltip>
                                </v-layout>
                                <v-flex
                                  xs12
                                  style="
                                    justify-content: center;
                                    align-items: center;
                                    display: flex;
                                  "
                                >
                                  <v-btn
                                    class="mt-3 mb-3"
                                    color="primary"
                                    @click="$refs.imagemInput.click(), indexSelecionado = index"
                                    large
                                  >
                                    Inserir imagem
                                  </v-btn>
                                </v-flex>
                              </v-stepper-content>
                            </v-stepper-items>
                          </v-stepper>
                          <v-layout wrap justify-space-between>
                            <v-btn
                              icon
                              color="info"
                              class="ma-3"
                              @click="step_image--"
                              :disabled="step_image === 1"
                            >
                              <v-icon>arrow_back</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="info"
                              class="ma-3"
                              @click="step_image++"
                              :disabled="imagens.length === step_image"
                            >
                              <v-icon>arrow_forward</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                          <v-layout wrap justify-space-between v-if="anuncioSelecionado" full-height>
                            <h1 style="text-align: center; width: 100%;" class="mb-2">
                              {{ anuncioSelecionado.titulo }}
                            </h1>
                            <v-flex xs12 sm12>
                              <v-layout justify-center  v-if="anuncioSelecionado.imagens.length > 0" full-height>
                                <v-carousel
                                  height="40em"
                                  width="40em"
                                >
                                <template v-for="(item, i) in anuncioSelecionado.imagens">
                                  <a
                                    :href="item"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    :key="`${i}a`"
                                  >
                                    <v-carousel-item
                                      :key="`${i}carousel`"
                                      :src="item"
                                      reverse-transition="fade-transition"
                                      transition="fade-transition"
                                    ></v-carousel-item>
                                  </a>
                                </template>
                                </v-carousel>
                              </v-layout>
                              <v-layout
                                v-else
                                justify-center
                                align-center
                                fill-height
                                style="
                                    height: 20em
                                "
                              >
                                  <v-icon size="20em">image</v-icon>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 class="mt-2 mb-2 subheading">
                              <b>Descrição:</b> {{ anuncioSelecionado.descricao }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Data de Inicio</b>
                              {{ anuncioSelecionado.data_inicio | formatDate('DD/MM/YYYY') }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Data de Expiração</b>
                              {{ anuncioSelecionado.data_fim | formatDate('DD/MM/YYYY') }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Possui restrição de estado:</b>
                              {{ anuncioSelecionado.limitar_a_estado ? 'SIM' : 'NÃO' }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Estado:</b>
                              {{ anuncioSelecionado.limitar_a_estado || 'Não definido' }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Possui restrição de cidade:</b>
                              {{ anuncioSelecionado.limitar_a_estado ? 'SIM' : 'NÃO' }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Cidade:</b>
                              {{ anuncioSelecionado.limitar_a_cidade || 'Não definido' }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Possui limite de visualização:</b>
                              {{ anuncioSelecionado.visualizacoes_por_usuario ? 'SIM' : 'NÃO' }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Número de Visualização por Usuário:</b>
                              {{ anuncioSelecionado.visualizacoes_por_usuario || 'Não definido' }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Número de visualizações:</b>
                              {{ anuncioSelecionado.total_visualizacoes }}
                            </v-flex>
                            <v-flex xs5 sm5 class="subheading">
                              <b>Ativo:</b>
                              {{ anuncioSelecionado.ativo ? 'SIM' : 'NÃO' }}
                            </v-flex>
                            <v-flex xs12 class="subheading">
                              <b>Link:</b>
                              <a
                                :href="anuncioSelecionado.link_redirecionamento"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {{ anuncioSelecionado.link_redirecionamento }}
                              </a>
                            </v-flex>
                            <v-flex xs12 class="subheading" v-if="anuncioSelecionado.destino_link_redirecionamento">
                              <b>Destino do Link:</b>
                              {{
                                destinos_link_redirecionamento.filter(link =>
                                link.value == anuncioSelecionado.destino_link_redirecionamento
                                )[0].text
                              }}
                            </v-flex>
                          </v-layout>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
            <v-card-actions
              v-if="step !== 1"
              class="justify-space-around"
            >
              <v-flex xs5>
                <v-btn
                  block
                  flat
                  @click="voltar"
                >
                  Voltar
                </v-btn>
              </v-flex>
              <v-flex xs5 v-if="step !== 4">
                <v-btn
                  block
                  flat
                  color="primary"
                  @click="btnConfirmar"
                >
                  Salvar
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
  </v-snackbar>
  </v-container>
</template>

<script>

import SmartLockMessage from '@/components/SmartLockMessage'
import CardAnuncio from '@/components/Anuncio'

export default {
  components: {
    SmartLockMessage,
    CardAnuncio
  },
  data () {
    const todayDate = new Date().toISOString().substr(0, 10)
    return {
      step: 1,
      step_image: 1,
      total_imagens: 1,
      cropping: false,
      valid: false,
      menuDataInicial: false,
      menuDataFinal: false,
      date_inicio: null,
      date_fim: null,
      today: Date.parse(todayDate),
      imagens: [undefined],
      imagem: undefined,
      anuncios: [],
      anuncioSelecionado: undefined,
      indexSelecionado: undefined,
      tem_restricao_cidade: false,
      tem_restricao_estado: false,
      limite_de_visualizacoes: false,
      isUpdate: false,
      destinos_link_redirecionamento: [
          { value: 1, text: 'Whatsapp' },
          { value: 2, text: 'Facebook' },
          { value: 3, text: 'Instagram' },
          { value: 4, text: 'Telegram' },
          { value: 5, text: 'Site' }
      ],
      formulario: {
        descricao: '',
        titulo: '',
        link_redirecionamento: '',
        data_inicio: null,
        data_fim: null,
        visualizacoes_por_usuario: 0,
        imagens: [],
        limitar_a_cidade: '',
        limitar_a_estado: '',
        destino_link_redirecionamento: 5
      },
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      pagination: {
        rowsPerPage: 6,
        page: 1
      },
      totalItems: 0
    }
  },
  beforeMount () {
    this.mudarPaginacao(this.$vuetify.breakpoint)
    if (this.headers) {
      this.pegarAnuncios()
    }
  },
  watch: {
    headers (val) {
      if (val) {
        this.pegarAnuncios()
      }
    },
    date_inicio (val) {
      this.menuDataInicial = false
      if (val) {
        this.formulario.data_inicio = val
          .split('-')
          .reverse()
          .join('/')
      } else {
        this.formulario.data_inicio = null
      }
    },
    date_fim (val) {
      this.menuDataFinal = false
      if (val) {
        this.formulario.data_fim = val
          .split('-')
          .reverse()
          .join('/')
      } else {
        this.formulario.data_fim = null
      }
    },
    tem_restricao_cidade (val) {
      if (!val) this.formulario.limitar_a_cidade = undefined
    },
    tem_restricao_estado (val) {
      if (!val) this.formulario.limitar_a_estado = undefined
    },
    limite_de_visualizacoes (val) {
      if (!val) this.formulario.visualizacoes_por_usuario = undefined
    },
    'pagination.page' (val) {
      if (val) {
        this.pegarAnuncios()
      }
    },
    tela (val) {
      this.mudarPaginacao(val)
    }
  },
  computed: {
    smartLock () {
      return this.$store.getters.smartLock
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    estados () {
      return this.$store.getters.estados
    },
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) {
        return 0
      }

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    tela () {
      return this.$vuetify.breakpoint
    }
  },
  methods: {
    mudarPaginacao (val) {
      if (val) {
        if (val.xs) this.pagination.rowsPerPage = 1
        else if (val.sm) this.pagination.rowsPerPage = 4
        else if (val.md) this.pagination.rowsPerPage = 6
        else if (val.lg) this.pagination.rowsPerPage = 8
        else if (val.xl) this.pagination.rowsPerPage = 12
      }
    },
    showSuccess (text) {
      this.snackbar.color = 'primary'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    showError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    voltar () {
      if (!this.isUpdate) this.$refs.form.reset()
      this.isUpdate = false
      this.anuncioSelecionado = undefined
      this.cropping = false
      this.step = 1
      this.imagens = [undefined]
      this.pegarAnuncios()
    },
    btnConfirmar () {
      switch (this.step) {
        case 2:
          if (this.isUpdate) {
            this.formulario = this.anuncioSelecionado
            this.atualizarAnuncios().then(() => {
              this.showSuccess('Dados editados com sucesso')
            }).catch(() => {
              this.showError('Não foi possível editar dados do anúncio')
            })
          } else this.cadastrarAnuncios()
          break
        case 3:
          this.pegarAnuncios()
          this.voltar()
          break
      }
    },
    visualizarAnuncio (anuncio) {
      this.anuncioSelecionado = anuncio
      this.step = 4
    },
    editarAnuncio (anuncio) {
      this.anuncioSelecionado = anuncio
      this.formulario = this.anuncioSelecionado
      this.isUpdate = true
      this.date_inicio = this.anuncioSelecionado.data_inicio
      this.date_fim = this.anuncioSelecionado.data_fim
      this.tem_restricao_cidade = !!this.anuncioSelecionado.limitar_a_cidade
      this.tem_restricao_estado = !!this.anuncioSelecionado.limitar_a_estado
      this.limite_de_visualizacoes = !!this.anuncioSelecionado.visualizacoes_por_usuario
      this.imagens = this.anuncioSelecionado.imagens.length > 0 ? this.anuncioSelecionado.imagens : [undefined]
      this.step = 2
    },
    pegarAnuncios () {
      this.$store.dispatch('anuncios', {
        method: 'GET',
        body: {
          page: this.pagination.page,
          page_size: this.pagination.rowsPerPage
        }
      }).then(json => {
        this.anuncios = json.results
        this.totalItems = json.count
      })
    },
    atualizarAnuncios () {
      const data = { ...this.anuncioSelecionado }
      if (this.isUpdate) {
        data.limitar_a_cidade = this.tem_restricao_cidade ? this.formulario.limitar_a_cidade : null
        data.limitar_a_estado = this.tem_restricao_estado ? this.formulario.limitar_a_estado : null
        data.visualizacoes_por_usuario = this.limite_de_visualizacoes ? this.formulario.visualizacoes_por_usuario : null
        data.data_inicio = this.formulario.data_inicio.split('/').reverse().join('-')
        data.data_fim = this.formulario.data_fim.split('/').reverse().join('-')
      }
      return this.$store.dispatch('anuncios', {
        method: 'PUT',
        id: this.anuncioSelecionado.id,
        body: data
      }).then(() => {
        this.pegarAnuncios()
        if (this.isUpdate && this.step === 2) this.step++
      })
    },
    cadastrarAnuncios () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('anuncios', {
          method: 'POST',
          body: {
            ...this.formulario,
            limitar_a_cidade: this.tem_restricao_cidade ? this.formulario.limitar_a_cidade : null,
            limitar_a_estado: this.tem_restricao_estado ? this.formulario.limitar_a_estado : null,
            visualizacoes_por_usuario: this.limite_de_visualizacoes ? this.formulario.visualizacoes_por_usuario : null,
            descricao: this.formulario.descricao ? this.formulario.descricao : null,
            data_inicio: this.formulario.data_inicio.split('/').reverse().join('-'),
            data_fim: this.formulario.data_fim.split('/').reverse().join('-')
          }
        }).then(json => {
          this.anuncioSelecionado = json
          this.showSuccess('O anúncio foi cadastrado com sucesso.')
          this.pegarAnuncios()
          this.step++
        }).catch(() => {
          this.showError('Não foi possível cadastrar anúncio.')
        })
      } else {
        this.showError('Você deve preencher todos os campos obrigatorios do formulário')
      }
    },
    carregarImagem (event) {
      this.imagem = null
      if (event.target.files && event.target.files[0]) {
        const imagem = event.target.files[0]
        const reader = new FileReader()
        reader.onloadend = e => {
          this.cropping = true
          this.$refs.croppie.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppie.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    recortarImagem () {
      const options = {
        type: 'base64',
        format: 'png'
      }
      options.circle = false
      this.$refs.croppie.result(options, output => {
        this.inserirArquivoFirebase(output)
        this.cropping = false
      })
    },
    inserirArquivoFirebase (imagem) {
      this.$store.dispatch('inserirArquivoFirebase', {
        arquivo: imagem,
        id: Date.parse(new Date()).toString(),
        local: this.anuncioSelecionado.id,
        tipo: 'png',
        rota: 'anuncios'
      }).then(url => {
        this.imagens[this.indexSelecionado] = url
        this.anuncioSelecionado.imagens = this.imagens.filter(item => !!item)
        this.indexSelecionado = undefined
        this.atualizarAnuncios()
        .then(() => {
          this.showSuccess('Imagem inserida com sucesso')
        }).catch(() => {
          this.showError('Não foi possível inserir imagem.')
        })
      })
    },
    removerImagem (imagem, index) {
      this.imagens.splice(index, 1)
      this.$store.dispatch('deletarArquivoFirebase', imagem).then(() => {
        this.anuncioSelecionado.imagens = this.imagens.filter(item => !!item)
        this.atualizarAnuncios()
        this.imagens = this.imagens.length === 0 ? [undefined] : this.imagens
        this.step_image = 1
        this.showSuccess('Imagem removida com sucesso')
      }).catch(() => {
        this.showError('Não foi possível remover a imagem.')
      })
    }
  }
}
</script>

<style>

</style>
